<script setup>
// store
const store = useLoginStore()
// store.domain.selected = store.domain.list[0].owner

// confirm
const confirm = async () => {
  console.log('in Domain vue ')
  if (!await store.enabled_2Fa()) store.showError('Login Fehlgeschlagen.')
  store.domain.confirmed = true
  store.user.domain = store.domain.selected
  /*   const selectedUser = store.user.list.find(user => user.domain === store.user.selected)
  store.user.key = selectedUser ? selectedUser.key : null */
}

// onMounted(async () => { if (!await store.checkUserTables()) store.showError('Login fehlgeschlagen.') })
</script>

<template>
  <form @submit.prevent="confirm">
    <div class="row row-cols-1 gy-3 px-3">
      <div class="col">
        <div class="form-group">
          <Select
            v-model="store.domain.selected"
            class=" "
            :pt="
              { root: { class: 'form-select form-control-lg col-12  bg-white' },
                wrapper: { class: 'w-100' },
                label: { class: 'text-secondary ' },
                overlay: { class: '   ' },
                listContainer: { class: 'bg-white mh-100' },
                option: { class: 'text-secondary ' },
              }"
            required
            :options="store.domain.list" option-label="domain"
          >
            <template #value="slotProps">
              <div class="overflow-hidden text-truncate">
                <i class="fas fa-swatchbook me-3 " /> {{ slotProps.value?.domain }}
              </div>
            </template>
            <template #option="slotProps">
              <div class="overflow-hidden text-truncate ">
                {{ slotProps.option.domain }}
              </div>
            </template>
          </Select>
          <!--   <option v-for="domain in store.domain.list" :key="domain" :value="domain.owner">
              {{ domain.domain }}
            </option> -->
        </div>
      </div>
      <div class="col">
        <Button
          type="submit"
          class="btn btn-primary btn-block btn-lg w-100"
          label="Confirm"
        />
      </div>
    </div>
  </form>
</template>
